import React from 'react';
import {Button} from '@spaced-out/ui-design-system/lib/components/Button';
import {useBookingMachine} from '../../hooks/useBookingMachine';


export const BookingFormBackButton = () => {
  const {bookingActor, bookingState} = useBookingMachine();

  const isBookingFormSubmittingState = bookingState.matches({
    bookingForm: 'submitting',
  });

  const handleBack = () => {
    bookingActor.send({type: 'back'});
  };
  return (
    <Button
      size="small"
      type="tertiary"
      onClick={handleBack}
      iconRightName="chevron-left"
      disabled={isBookingFormSubmittingState}
    />
  );
};
